import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {useUserDevice} from "@pg-mono/user-device";

import {AuthModalVariant} from "../../../auth/components/auth_modal/AuthModalHeaderVariants";
import {startRegistrationFlow} from "../../../auth/state/registration_flow_slice";
import {useShouldHidePrices} from "../../../hooks/use_should_hide_prices";
import {useAppDispatch, useAppSelector} from "../../../store/hooks";
import {UserSource} from "../../../tracking/tracking_utils/user_source";
import {openLoginDrawer, openSignupDrawer} from "../../state/semantic_search_auth_slice";
import {AI_ASSISTANT_AUTH_CUSTOM_LABEL, hitAiAssistantCta} from "../../tracking/semantic_search_gtm_events";

export const SemanticSearchSignup = () => {
    const dispatch = useAppDispatch();
    const {isMobile} = useUserDevice();
    const isSemanticSearchOpen = useAppSelector((state) => state.semanticSearchModal.isSemanticSearchOpen);
    const {isUserLoggedIn, hasCompleteProfile, hasPhoneVerified} = useShouldHidePrices();

    // Use this login/register variant when user is using fullscreen modal for AI advisor
    const startAuthFlowVariantB = (showLoginForm: boolean) => {
        dispatch(
            startRegistrationFlow({
                isUserLoggedIn,
                hasCompleteProfile,
                hasPhoneVerified,
                userSource: UserSource.HIDDEN_PRICES_BANNER,
                gtmSourceSection: AI_ASSISTANT_AUTH_CUSTOM_LABEL,
                modalVariant: "hidden_prices_variant_b",
                titleVariant: AuthModalVariant.HIDDEN_PRICES_VARIANT_B,
                showLoginForm,
                amplitudePlacement: "rp_semantic_search_auth"
            })
        );
    };

    const handleSignupClick = () => {
        hitAiAssistantCta("click", "Załóż konto");

        if (isSemanticSearchOpen && !isMobile) {
            startAuthFlowVariantB(false);
            return;
        }

        dispatch(openSignupDrawer());
    };

    const handleLoginClick = () => {
        hitAiAssistantCta("click", "Zaloguj się");

        if (isSemanticSearchOpen && !isMobile) {
            startAuthFlowVariantB(true);
            return;
        }

        dispatch(openLoginDrawer());
    };

    return (
        <div className={signupButtonWrapper}>
            <Button variant="filled_primary" size="x-small" onClick={handleSignupClick}>
                Załóż konto
            </Button>
            <Button variant="outlined_secondary" size="x-small" onClick={handleLoginClick}>
                Zaloguj się
            </Button>
        </div>
    );
};

const signupButtonWrapper = css({
    display: "flex",
    gap: 2
});
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {useUserDevice} from "@pg-mono/user-device";

import {AuthModalVariant} from "../../../auth/components/auth_modal/AuthModalHeaderVariants";
import {startRegistrationFlow} from "../../../auth/state/registration_flow_slice";
import {useShouldHidePrices} from "../../../hooks/use_should_hide_prices";
import {useAppDispatch, useAppSelector} from "../../../store/hooks";
import {UserSource} from "../../../tracking/tracking_utils/user_source";
import {openLoginDrawer, openSignupDrawer} from "../../state/semantic_search_auth_slice";
import {AI_ASSISTANT_AUTH_CUSTOM_LABEL, hitAiAssistantCta} from "../../tracking/semantic_search_gtm_events";

export const SemanticSearchSignup = () => {
    const dispatch = useAppDispatch();
    const {isMobile} = useUserDevice();
    const isSemanticSearchOpen = useAppSelector((state) => state.semanticSearchModal.isSemanticSearchOpen);
    const {isUserLoggedIn, hasCompleteProfile, hasPhoneVerified} = useShouldHidePrices();

    // Use this login/register variant when user is using fullscreen modal for AI advisor
    const startAuthFlowVariantB = (showLoginForm: boolean) => {
        dispatch(
            startRegistrationFlow({
                isUserLoggedIn,
                hasCompleteProfile,
                hasPhoneVerified,
                userSource: UserSource.HIDDEN_PRICES_BANNER,
                gtmSourceSection: AI_ASSISTANT_AUTH_CUSTOM_LABEL,
                modalVariant: "hidden_prices_variant_b",
                titleVariant: AuthModalVariant.HIDDEN_PRICES_VARIANT_B,
                showLoginForm,
                amplitudePlacement: "rp_semantic_search_auth"
            })
        );
    };

    const handleSignupClick = () => {
        hitAiAssistantCta("click", "Załóż konto");

        if (isSemanticSearchOpen && !isMobile) {
            startAuthFlowVariantB(false);
            return;
        }

        dispatch(openSignupDrawer());
    };

    const handleLoginClick = () => {
        hitAiAssistantCta("click", "Zaloguj się");

        if (isSemanticSearchOpen && !isMobile) {
            startAuthFlowVariantB(true);
            return;
        }

        dispatch(openLoginDrawer());
    };

    return (
        <div className={signupButtonWrapper}>
            <Button variant="filled_primary" size="x-small" onClick={handleSignupClick}>
                Załóż konto
            </Button>
            <Button variant="outlined_secondary" size="x-small" onClick={handleLoginClick}>
                Zaloguj się
            </Button>
        </div>
    );
};

const signupButtonWrapper = css({
    display: "flex",
    gap: 2
});
